import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card'
import { Button } from '../components/ui/button'

export const Route = createFileRoute('/account-deleted')({
  component: AccountDeleted,
})

function AccountDeleted() {
  const handleGoHome = () => {
    window.location.href = '/'
  }

  return (
    <div className="container mx-auto max-w-2xl px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl text-green-600">Account Deleted Successfully</CardTitle>
          <CardDescription>
            Your account has been permanently deleted
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="h-5 w-5 rounded-full bg-green-500 flex items-center justify-center mt-0.5">
                <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold text-green-800 mb-2">Deletion Complete</h3>
                <p className="text-green-700 mb-3">
                  Your Trackplicant account and all associated data have been permanently removed from our systems.
                </p>
                <p className="text-green-700 text-sm">
                  You have been logged out of your account.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center space-y-4">
            <div>
              <p className="text-gray-600 mb-4">
                Thank you for using Trackplicant. We're sorry to see you go.
              </p>
              <p className="text-sm text-gray-500">
                If you have any feedback about your experience, please contact us at{' '}
                <a href="mailto:support@trackplicant.com" className="text-blue-600 hover:underline">
                  support@trackplicant.com
                </a>
              </p>
            </div>

            <Button 
              onClick={handleGoHome}
              className="w-full max-w-sm"
            >
              Return to Homepage
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}